module.exports = __webpack_public_path__ + "img/dashboardMHH4.6af21f37.png";